module.exports = __webpack_public_path__ + "img/caret-right-gray-16x16.21e523dc.svg";